import { render, staticRenderFns } from "./PlanLimitsBanner.vue?vue&type=template&id=c4c011b6&"
import script from "./PlanLimitsBanner.vue?vue&type=script&lang=js&"
export * from "./PlanLimitsBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports